export interface CameraSettings {
  FOV: number;
  ASPECT: number;
  NEAR: number;
  FAR: number;
}

export interface RaycasterSettings {
  threshold: number;
}

export enum setViewType {
  FRONT = "-y",
  BACK = "+y",
  LEFT = "-x",
  RIGHT = "+x",
  TOP = "+z",
  BOTTOM = "-z",
  TOP_SAME_DIRECTION = "@z",
}

export interface ITextScale {
  orthographic: number;
  perspective: number;
}

export const DEFAULT_POINT_SIZE = 4;
export const ORIGINAL = "original";
export const EDIT_MEASUREMENT_COLOR = 0x00ffff;
export const PREVIEW_MEASUREMENT_COLOR = 0x00ffff;
// export const NORMAL_MEASUREMENT_COLOR = 0xff1493;
// export const SELECTED_MEASUREMENT_COLOR = 0x0000ff;
export const MEASUREMENT_SPHERE_SIZE = 4;
export const TOUCH_OFFSET = -50;
export const PICKPOINT_TEXT_HEIGHT = 1;
export const PICKPOINT_TEXT_SIZE = 0.25;

export const NORMAL_MEASUREMENT_COLOR = 0x167a1e;
export const SELECTED_MEASUREMENT_COLOR = 0x1a80d9;
export const HOVERED_MEASUREMENT_COLOR = 0x11aaf0;

export const DEFAULT_LINE_RADIUS = 0.125;
export const SELECTED_LINE_RADIUS = 0.25;
export const HOVERED_LINE_RADIUS = 0.25;

export const DEFAULT_ARROW_TOP_RADIUS = 0.125;
export const SELECTED_ARROW_TOP_RADIUS = 0.25;
export const HOVERED_ARROW_TOP_RADIUS = 0.25;

export const DEFAULT_ARROW_BOTTOM_RADIUS = 0.75;
export const SELECTED_ARROW_BOTTOM_RADIUS = 0.75;
export const HOVERED_ARROW_BOTTOM_RADIUS = 0.75;

export const DEFAULT_TUBE_CONSTANT_ORTHOGRAPHIC = 0.0015;
export const SELECTED_TUBE_CONSTANT_ORTHOGRAPHIC = 0.003;
export const HOVERED_TUBE_CONSTANT_ORTHOGRAPHIC = 0.003;

export const DEFAULT_TUBE_CONSTANT_PERSPECTIVE = 0.003;
export const SELECTED_TUBE_CONSTANT_PERSPECTIVE = 0.006;
export const HOVERED_TUBE_CONSTANT_PERSPECTIVE = 0.006;

export const DEFAULT_SPHERE_RADIUS = 0.25;
export const SELECTED_SPHERE_RADIUS = 0.35;
export const HOVERED_SPHERE_RADIUS = 0.35;

// export const DEFAULT_MEASUREMENT_TEXT_BGCOLOR = "rgba(22,122,30,0.7)";
export const DEFAULT_MEASUREMENT_TEXT_BGCOLOR = "rgba(0,0,0,0.3)";
export const SELECTED_MEASUREMENT_TEXT_BGCOLOR = "rgba(26,128,217,1.0)";
export const HOVERED_MEASUREMENT_TEXT_BGCOLOR = "rgba(26,128,240,0.3)";

export const DOUBLE_CLICK_TIMEOUT = 300;
export const DOUBLE_CLICK_OFFSET = 5;

export const TEXT_SIZE = 2.5;

export const PHOTOSHOT_ACCURACY_COLOR = {
  LOW: 0xff0000,
  MEDIUM: 0x0000ff,
  HIGH: 0x00ff00,
};

export enum SCENE_TYPE {
  STREAM_POINTCLOUD = "stream-pointcloud",
  STATIC_POINTCLOUD = "static-pointcloud",
  MEASUREMENT = "measurement",
  POINTPICK = "point-pick",
  BACKGROUND = "background",
  FOREGROUND = "foreground",
}

export const PHOTOSHOT_CONFIG = {
  COLORS: {
    STATIC_LOW: 0xab0000,
    FOCUS_LOW: 0xf58080,
    STATIC_MEDIUM: 0xf5c32f,
    FOCUS_MEDIUM: 0xf5e597,
    STATIC_HIGH: 0x0ceb1e,
    FOCUS_HIGH: 0x86f58f,
    BODY_FOCUS: 0x90ffb99,
    BODY_STATIC: 0x90fb99,
    FACE_STATIC: 0x90fb99,
    FACE_FOCUS: 0x90ff99,
  },
  HEAD_SIZES: {
    GPS: 0.03,
    LOW: 0.03,
    MEDIUM: 0.03,
    HIGH: 0.03,
  },
};
